import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {MatSliderModule} from '@angular/material/slider';
import {OverlayModule} from '@angular/cdk/overlay';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatTabsModule} from '@angular/material/tabs';
import {MatIconModule} from '@angular/material/icon';
import {MatCardModule} from '@angular/material/card';
import {MatChipsModule} from '@angular/material/chips';
import {MatGridListModule} from '@angular/material/grid-list';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MeetingComponent } from './meeting/meeting.component';
import { LoginComponent } from './login/login.component';
import { CaroseulComponent } from './caroseul/caroseul.component';
import { SkillComponent } from './skill/skill.component';
import { LocationComponent } from './location/location.component';
import { FooterComponent } from './footer/footer.component';
import { MissionComponent } from './mission/mission.component';
import {environment} from '../environments/environment.prod';
import {AngularFirestoreModule} from '@angular/fire/firestore';
import {AngularFireAuthModule} from '@angular/fire/auth';
import {AngularFireModule} from '@angular/fire';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import { CardService } from '../shared/card.service';
import { NgxPayPalModule } from 'ngx-paypal';
import { NavbarComponent } from './navbar/navbar.component';
import { ServiziComponent } from './servizi/servizi.component';
import { RecensioneComponent } from './recensione/recensione.component';
import { PutrecensioneComponent } from './putrecensione/putrecensione.component';
import {HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ObiettivicarouselComponent } from './obiettivicarousel/obiettivicarousel.component';




@NgModule({
  declarations: [
    AppComponent,
    MeetingComponent,
    LoginComponent,
    CaroseulComponent,
    SkillComponent,
    LocationComponent,
    FooterComponent,
    MissionComponent,
    NavbarComponent,
    ServiziComponent,
    RecensioneComponent,
    PutrecensioneComponent,
    ObiettivicarouselComponent,

  ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        MatSliderModule,
        MatTabsModule,
        MatIconModule,
        MatCardModule,
        OverlayModule,
        MatChipsModule,
        MatGridListModule,
        NgbModule, AngularFireModule.initializeApp(environment.firebaseConfig),
        AngularFireAuthModule, FormsModule,
        RouterModule,
        AngularFireModule.initializeApp(environment.firebaseConfig),
        AngularFirestoreModule,
        BrowserModule,
        NgxPayPalModule, ReactiveFormsModule,

    ],
  providers: [AngularFirestoreModule, CardService,
      { provide: LocationStrategy, useClass: HashLocationStrategy}],
  bootstrap: [AppComponent]
})
export class AppModule { }
